// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3 23H21V1H3V23ZM14.0021 6.68761L11.504 8.75011V3.00011L16.5001 3.00011L16.5001 8.75011L14.0021 6.68761Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-course-filled')
export default class CourseFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'course-filled',
    }
  }
}
